import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from 'store';

import { ShopState } from './shop.types';

const initialState: ShopState = {
  activeProductName: 'Product details',
  shippingAddress: {
    address: '',
    address2: '',
    city: '',
    state: '',
    zipCode: ''
  }
};

const shopSlice = createSlice({
  initialState,
  name: 'settings',
  reducers: {
    resetStore: () => initialState,
    setActiveProductName: (state, action: PayloadAction<string>) => {
      state.activeProductName = action.payload;
    },
    setShippingAddress: (state, action: PayloadAction<ShopState['shippingAddress']>) => {
      state.shippingAddress = action.payload;
    }
  }
});

export const { resetStore, setActiveProductName, setShippingAddress } = shopSlice.actions;

export const selectShop = (state: RootState) => state.shop;

export default shopSlice.reducer;
